"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.capitalizeFirstLetter = exports.removeLeadingZero = exports.removeNonNumeric = exports.addThousandSeparator = void 0;
var DOTS_REGEX = /\B(?=(\d{3})+(?!\d))/g;
var NON_NUMERIC_REGEX = /[^0-9]/g;
var addThousandSeparator = function (num) {
    if (num === void 0) { num = ''; }
    return num.replace(DOTS_REGEX, '.');
};
exports.addThousandSeparator = addThousandSeparator;
var removeNonNumeric = function (num) { return num.replace(NON_NUMERIC_REGEX, ''); };
exports.removeNonNumeric = removeNonNumeric;
var removeLeadingZero = function (num) {
    var parsedValue = parseInt(num, 10);
    if (!parsedValue || isNaN(parsedValue)) {
        return '';
    }
    return parsedValue.toString();
};
exports.removeLeadingZero = removeLeadingZero;
var capitalizeFirstLetter = function (text) {
    return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
};
exports.capitalizeFirstLetter = capitalizeFirstLetter;
